import { render, staticRenderFns } from "./EStoreOrdersHistory.vue?vue&type=template&id=d83ca924&"
import script from "./EStoreOrdersHistory.vue?vue&type=script&lang=js&"
export * from "./EStoreOrdersHistory.vue?vue&type=script&lang=js&"
import style0 from "./EStoreOrdersHistory.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPullToRefresh,QInput,QIcon,QChip,QPagination,QTable,QInnerLoading,QTr,QTh,QTd,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPullToRefresh,QInput,QIcon,QChip,QPagination,QTable,QInnerLoading,QTr,QTh,QTd,QBtn})
